<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>휴직기간</v-list-item-title>
          <v-list-item-subtitle>{{ leaveDt }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>휴직종료 예정일</v-list-item-title>
          <v-list-item-subtitle> {{ leaveEndDt }} </v-list-item-subtitle>
          <v-list-item-subtitle
            >복직예정일은 {{ reinstPlanYmd }} 일 입니다</v-list-item-subtitle
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title>자녀명/관계</v-list-item-title>
          <v-list-item-subtitle>{{ famInfo }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>생년월일</v-list-item-title>
          <v-list-item-subtitle> {{ famYmd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>휴직기간</v-list-item-title>
          <v-list-item-subtitle> {{ limitTerm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>육아휴직연장 후 잔여일수</v-list-item-title>
          <v-list-item-subtitle> {{ remainDay }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>변경사유</v-list-item-title>
          <v-list-item-subtitle> {{ refReason }} </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { getExtParLeaDtAppDetMapDetail } from '@/api/workStatus';
import { mapMutations } from 'vuex';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    reInDate: '',
    period: '',
    refReason: '',
    leaveDt: '',
    famInfo: '',
    famYmd: '',
    leaveEndDt: '',
    reinstPlanYmd: '',
    limitTerm: '',
    useDay: '',
    remainDay: '',
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {},

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    addDate(pInterval, pAddVal, pYyyymmdd, pDelimiter) {
      var yyyy;
      var mm;
      var dd;
      var cDate;
      var cYear, cMonth, cDay;

      if (pYyyymmdd == '') {
        return '';
      }

      if (pDelimiter != '') {
        pYyyymmdd = pYyyymmdd.replace(eval('/\\' + pDelimiter + '/g'), '');
      }

      yyyy = pYyyymmdd.substr(0, 4);
      mm = pYyyymmdd.substr(4, 2);
      dd = pYyyymmdd.substr(6, 2);

      if (pInterval == 'yyyy') {
        yyyy = yyyy * 1 + pAddVal * 1;
      } else if (pInterval == 'm') {
        mm = mm * 1 + pAddVal * 1;
      } else if (pInterval == 'd') {
        dd = dd * 1 + pAddVal * 1;
      }

      cDate = new Date(yyyy, mm - 1, dd); // 12월, 31일을 초과하는 입력값에 대해 자동으로 계산된 날짜가 만들어짐.
      cYear = cDate.getFullYear();
      cMonth = cDate.getMonth() + 1;
      cDay = cDate.getDate();

      cMonth = cMonth < 10 ? '0' + cMonth : cMonth;
      cDay = cDay < 10 ? '0' + cDay : cDay;

      //if (pDelimiter != "") {
      return cYear + pDelimiter + cMonth + pDelimiter + cDay;
      //} else {
      //	return cYear + cMonth + cDay;
      //}
    },
  },

  async created() {
    let params = {
      searchApplSeq: this.appInfoParam.applSeq,
    };

    let response = await getExtParLeaDtAppDetMapDetail(params);
    console.dir('getExtParLeaDtAppDetMapDetail : '+JSON.stringify(response));

    this.leaveDt =
      response.data.data.refSdate + ' ~ ' + response.data.data.refEdate;

    this.famInfo = response.data.data.famNm + ' / ' + response.data.data.famCd;
    this.famYmd = response.data.data.famYmd + ' / ' + response.data.data.famAge;
    this.famSeq = response.data.data.famSeq;
    this.refReason = response.data.data.note;
    this.reinstPlanYmd = response.data.data.reinstPlanYmd;

    //this.reInDate = response.data.data.orgTmpRestEndPlanYmd; //this.addDate('d', 1, response.data.data.tmpRestEndPlanYmd,'-', );

    const oldDate = new Date(response.data.data.refSdate);

    const newDate = new Date(response.data.data.tmpRestEndPlanYmd);

    let diff = Math.abs(newDate.getTime() - oldDate.getTime());
    diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

    this.period = diff + 1;
    this.leaveEndDt =
      response.data.data.tmpRestEndPlanYmd + ' / ' + this.period + '일';


    this.limitTerm = response.data.data.caDays;
    this.useDay = response.data.data.usedDaysBefore;
    this.remainDay = response.data.data.remainDaysBefore; 

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: {},
};
</script>
